export enum Aplicacao {
  PODE_REGULARIZAR = 'PODE_REGULARIZAR',
  REURB = 'REURB'
}
